(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-piece-view]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.hidden = false;
      button.addEventListener('click', () => {
        const back = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', String(back));
        button.textContent = back ? button.dataset.front : button.dataset.back;
        button.closest('.fm-uniform__piece').classList.toggle('is-back', back);
      });
    });
    scope.querySelectorAll('[data-detail-study]').forEach(root => {
      if (root.dataset.bound) return;
      root.dataset.bound = 'true';
      const buttons = [...root.querySelectorAll('[data-detail-choice]')];
      const figures = [...root.querySelectorAll('[data-detail-photo]')];
      if (!buttons.length || buttons.length !== figures.length) return;
      const copy = root.querySelector('[data-detail-copy]');
      const choose = (index, focus = false) => {
        figures.forEach((figure, i) => { figure.hidden = i !== index; });
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        copy.textContent = buttons[index].dataset.caption;
        if (focus) buttons[index].focus();
      };
      root.querySelector('[data-detail-controls]').hidden = false;
      root.classList.add('is-interactive');
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => choose(index));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          choose(event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length, true);
        });
      });
      choose(0);
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
